import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import WorkspaceAppResource from "./WorkspaceAppResource";
import {LOAN_TYPES} from "./PropertyMortgageAppResource";

class PropertyAttomHiddenMortgageAppResource extends AppResource {
    /**
     * @returns {string}
     */
    appResourceType() {
        return 'property-attom-hidden-mortgage';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'properties/attoms/hiddens/mortgages';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'workspaceUuid',
            'type',
            's3RecorderImportId',
            's3RecorderImportMortgageField',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            workspace: WorkspaceAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            workspace: 'workspaceUuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {

        return {
            workspaceUuid: {
                type: 'string',
                presence: true,
            },

            type: {
                inclusion: LOAN_TYPES,
                presence: true,
            },

            s3RecorderImportId: {
                presence: true,
                numericality: true,
            },
            s3RecorderImportMortgageField: {
                presence: true,
                type: 'string',
            },
        };
    }

}

export default PropertyAttomHiddenMortgageAppResource;
